export default "__VITE_ASSET__Drv$7GPx__"